<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/">里世界玩家终端</router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link class="nav-link" to="/profile">网格用时</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/ownership-changes" v-if="user() && user().isadmin">所属/破坏查询</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/allgrids" v-if="user() && user().isadmin">全部网格</router-link>
          </li>
          <template v-if="user()">
          <li><div style="border-right: 1px solid #CCCCCC;height: 30px; margin:5px;"/></li>
            <li class="nav-item">
              <router-link class="nav-link" to="/mygrids">我的网格</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/myhangar">我的船坞</router-link>
            </li>
          </template>
          <template v-else>
            <li class="nav-item">
              <a class="btn btn-sm btn-outline-success" style="margin-top:5px;" href="/login">登录后使用更多功能</a>
            </li>
          </template>
          <!-- 在此处添加更多导航链接 -->
        </ul>
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li v-if="user()" class="nav-item">
              <img :src="user().avatar" alt="avatar" class="rounded-circle" width="30" height="30">
              <span style="line-height: 30px;">{{ user().personaname }}</span>
              <button style="margin-left: 10px;" type="button" class="btn btn-sm btn-outline-danger" href="#" @click="logout">登出</button>
          </li>
          <li v-else class="nav-item">
            <a class="btn btn-sm btn-outline-success" href="/login">登录</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Header',
  inject: ['user', 'logout'],
  mounted() {
    // 检查Bootstrap的collapse组件是否有效
    const bsCollapse = new bootstrap.Collapse(document.getElementById('navbarNav'), {
      toggle: false
    });
    console.log('Bootstrap Collapse is initialized:', bsCollapse);
  }
};
</script>

<style scoped>
.navbar {
  background-color: #1a1a1a;
  position: fixed;
  border-bottom: none;
  width: 100%;
  background: linear-gradient(to right, #001020, #200020, #001010);
}

.navbar-brand {
  color: #00e0ff;
  text-shadow: 0 0 5px rgba(0, 224, 255, 0.5);
  
}

.nav-link {
  color: #00e0ff;
}

.nav-link:hover {
  color: #fff;
}

.nav-item img {
  margin-right: 8px;
}

</style>
